import { GET_QUICONTACTER } from "../actions/quicontacter.actions";

const initialState = {};

export default function quicontacterReducer(state = initialState, action) {
  switch (action.type) {
    case GET_QUICONTACTER:
      return action.payload;
    default:
      return state;
  }
}
